import { useRouter } from "next/router";
import { Col, Image } from "react-bootstrap";
import Heading from "src/components/Heading";
import Paragraph from "src/components/Paragraph";
import constants from "src/constants";

function OurStory() {
  const { locale: lang } = useRouter();

  switch (lang) {
    case `cs`:
      return (
        <>
          <Col sm={7}>
            <Heading type="h1" title={`Příběh Vivido`} />
            <Heading
              type="h2"
              title={`Vivido pomáhá uživatelům i instruktorům usnadnit jejich on-line život.`}
              style={{ color: constants.Theme.primary }}
            />
            <Paragraph size="xn">
              Máme jednoduché heslo Žít život s lehkostí. Současná on-line
              zkušenost s cvičením jógy, ať už ze strany jogínů nebo
              instruktorů, je neuspokojivá. Našim cílem je přinést vysoký
              standard kvality služeb běžný např. v segmentu ubytování a stát se
              přirozenou volbou pro jogíny - po celém světě. Jednoduše: chceme
              pomáháme jogínům i instruktorům usnadnit jejich on-line život.
            </Paragraph>
            <Paragraph size="xn">
              Pro instruktory to konkrétně znamená: udržitelný příjem, méně
              administrativy a více času na výuku. Jogínům chceme přinést zdroj
              dobré nálady, prevenci pro tělo a potenciál k růstu. A to vše díky
              tomu, že budeme schopni doručit obsah, který má pro jejich život
              význam.
            </Paragraph>
          </Col>
          <Col sm={5} style={{ textAlign: `center`, paddingTop: `25px` }}>
            <Image
              src={
                constants.Paths.imagesUrl +
                `/images/posts/pavol-hudran-founder-of-vivido.jpg`
              }
              alt={`Pavol Hudran - zakladatel Vivido`}
              style={{ maxHeight: `600px` }}
            />
          </Col>
        </>
      );
    case `sk`:
      return (
        <>
          <Col sm={7}>
            <Heading type="h1" title={`Príbeh Vivido`} />
            <Heading
              type="h2"
              title={`Vivido pomáha používateľom aj inštruktorom uľahčiť ich on-line život.`}
              style={{ color: constants.Theme.primary }}
            />
            <Paragraph size="xn">
              Máme jednoduché heslo Žiť život s ľahkosťou. Súčasná on-line
              skúsenosť s cvičením jogy, či už zo strany jogínov alebo
              inštruktorov, je neuspokojivá. Našim cieľom je priniesť vysoký
              štandard kvality služieb bežný napr. v segmente ubytovania a stať
              sa prirodzenou voľbou pre jogíny - po celom svete. Jednoducho:
              chceme pomáhame jogínom aj inštruktorom uľahčiť ich on-line život.
            </Paragraph>
            <Paragraph size="xn">
              Pre inštruktorov to konkrétne znamená: udržateľný príjem, menej
              administratívy a viac času na výučbu. Jogínom chceme priniesť
              zdroj dobrej nálady, prevenciu pre telo a potenciál k rastu. A to
              všetko vďaka tomu, že budeme schopní doručiť obsah, ktorý má pre
              ich život význam.
            </Paragraph>
          </Col>
          <Col sm={5} style={{ textAlign: `center`, paddingTop: `25px` }}>
            <Image
              src={
                constants.Paths.imagesUrl +
                `/images/posts/pavol-hudran-founder-of-vivido.jpg`
              }
              alt={`Pavol Hudran - zakladateľ Vivido`}
              style={{ maxHeight: `600px` }}
            />
          </Col>
        </>
      );
    default:
      // also EN
      return (
        <>
          <Col sm={7}>
            <Heading type="h1" title={`Vivido's story`} />
            <Heading
              type="h2"
              title={`Vivido helps users and instructors make their online lives easier.`}
              style={{ color: constants.Theme.primary }}
            />
            <Paragraph size="xn">
              We have a simple motto Live life with ease. Current online
              experience of practicing yoga, either by yogis or instructors, is
              unsatisfactory. Our goal is to bring high standard of service
              quality common, for example, in the accommodation segment and
              becoming a natural choice for yogis - all over the world. Simply:
              we want we help yogis and instructors to make their online life
              easier.
            </Paragraph>
            <Paragraph size="xn">
              For instructors, this means specifically: sustainable income, less
              administration and more time for teaching. We want to bring a
              resource to yogis good moods, prevention for the body and
              potential for growth. And all thanks that we will be able to
              deliver content that is relevant to their lives importance.
            </Paragraph>
          </Col>
          <Col sm={5} style={{ textAlign: `center`, paddingTop: `25px` }}>
            <Image
              src={
                constants.Paths.imagesUrl +
                `/images/posts/pavol-hudran-founder-of-vivido.jpg`
              }
              alt={`Pavol Hudran - founder of Vivido`}
              style={{ maxHeight: `600px` }}
            />
          </Col>
        </>
      );
  }
}

export default OurStory;
